import React, { useEffect } from 'react';
import Slider from './Slider';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Projects = () => {
  useEffect(() => {
    let tl = gsap.timeline();
    tl.from('#proj-title', {
      x: 600,
    });

    ScrollTrigger.create({
      trigger: '.gallery',
      start: 'top bottom',
      end: 'top 25%',
      scrub: true,
      animation: tl,
    });
  }, []);

  return (
    <div>
      <div id="projects">
        <div id="proj-title">Projects</div>
      </div>
      <Slider />
    </div>
  );
};

export default Projects;
